module.exports = __webpack_public_path__ + "img/banner-1.b781d499.png";